import { Option, LabeledSelect } from 'components/Select';
import { rm } from 'utils';
import {
  Attribute,
  useConfigurator,
  useVisibility
} from 'views/ProductPage/configurators/useConfigurator';

export const AttributeSelect = (a: Attribute) => {
  const { onSelectChange } = useConfigurator();
  const isVisible = useVisibility();
  const onChange = (value: string) => onSelectChange(a.id, value);
  return (
    <LabeledSelect
      label={a.name}
      isSelected={!!a.selected}
      placeHolder={rm('product_variant_choose')}
      onChange={onChange}
      selectedValue={a.selected}
      labelFormat={`{0} ${a.unit || ''}`}
      scrollable
      disabled={!isVisible(a.id)}
    >
      {a.values.map(value => (
        <Option key={value.value} {...value} />
      ))}
    </LabeledSelect>
  );
};
